import React, { Component } from 'react'
import FileDropZone from './FileDropZone'
import FileManager from '../Widgets/FileManager/FileManager'
import Modal from './Modal'
import { modelUploadProgressBars, reviewButton, checkDevKeys} from '../../Templates/functions'
import axios from 'axios'
import {WebSocketEventEmitter} from '../../Websockets/WebSocketEventEmitter'

// While a model is being decimated, the list is asked for again this often. The
// backend reads the decimator's progress from the database each time.
const REFRESH_MS = 3000
const PROCESSING = ['Upload', 'Uploaded', 'Queued', 'Decimating_1', 'Decimating_2', 'Decimating_3', 'Decimating_4', 'Decimating_5', 'Packaging']

class ModelUploader extends Component {
    signal = axios.CancelToken.source()
    refreshing = false
    state = {
        selectedFile: null,
        isLoading: true,
        openModal: false
    }

    componentDidMount = () => {
        // document.addEventListener("keydown", this.devCheck)
        WebSocketEventEmitter.on('ModelUploaderProgress', (event) => {
            this.processWebsocketMessage(event.sender, event.message, event.process, event.fileName);
        })
        this.loadData()
        this.refreshTimer = setInterval(this.refreshWhileProcessing, REFRESH_MS)
    }

    // Uploads still on their way have no ID yet; their upload request reports back.
    refreshWhileProcessing = () => {
        const processing = Object.values(this.props.fileList)
            .some(({ _id, progress, state }) => _id && PROCESSING.includes(progress || state))
        if (processing && !this.refreshing) {
            this.refreshList()
        }
    }

    refreshList = () => {
        this.refreshing = true
        return this.props.fetchFileListData(this.signal.token)
            .catch(err => {
                if (!axios.isCancel(err)) {
                    console.debug('Model Uploader refresh failed', err.message)
                }
            })
            .finally(() => {
                this.refreshing = false
            })
    }

    processWebsocketMessage(sender, message, process, filename){
        let index = this.findIndex(this.props.fileList, filename)
        let file = {
            _id: sender,
            name: filename,
            progress: process,
            message: message
        }
        switch (process) {
            case 'Queued':
            case 'Upload':
            case ('Decimating_1'):
            case ('Decimating_2'):
            case ('Decimating_3'):
            case ('Decimating_4'):
            case ('Decimating_5'):
            case ('Packaging'):
            case ('Review'):
            case ('Failed'):
                this.saveData(file, index)
                break
            case ('Approved'):
                this.props.removeFileFromList(index, file._id)
                break
            default:
                console.log("rejected message", message)
                console.log("Web socket message not intended for this component")
                break
        }
    }
    componentWillUnmount = () => {
        document.removeEventListener("keydown", this.devCheck)
        clearInterval(this.refreshTimer)
        this.signal.cancel('Api is being canceled');
    }

    loadData = () => {
        let signalToken = this.signal.token
        Promise.all(
            this.props.fetchFileListData(signalToken)
        ).then(([res1, res2, res3]) => {
            this.setState({
                isLoading: false
            })
        }).catch(err => {
            if (axios.isCancel(err)) {
                console.info('Model Uploader Page - ', err.message)
            } else {
                console.debug('Error', err.message)
            }
        });
    }
    
    approveModel = (model_id, decimationSetting, name, backgroundColor) => {
        let payload = {
            model_id,
            decimationSetting,
            name,
            backgroundColor: backgroundColor.slice(1)
        }
        // Then ask for the list again, which no longer has the approved model.
        this.props.approveModel(payload)
            .catch(err => console.error('Approving the model failed', err))
            .finally(this.refreshList)
        this.closeModal()
    }

    removeModel = (id) => {
        this.props.removeModel(id)
            .catch(err => console.error('Removing the model failed', err))
            .finally(this.refreshList)
        this.props.removeFileFromList(this.state.index)
        this.closeModal()
    }

    // devCheck = (e) => {
    //     checkDevKeys(e.keyCode, this.state.devKeyPresses, (value) => this.setState({ devKeyPresses: value }), () => this.setState({
    //         openModal: true,
    //         modelId: "5fc6ecb892cb0213f0a7faa7"
    //     }))
    // }

    closeModal = () => {
        this.setState(prevState => ({
            openModal: !prevState.openModal
        }))
    }


    findIndex = (fileList, fileName) => {
        let fileListLength = Object.entries(fileList).length
        if (!fileListLength) return 0;
         if (fileName) {
             for (const index in fileList) {
                 if (fileList[index].name === fileName) {
                     return index
                 }
             }
             
             return fileListLength
        }
    }

    saveData = (file, index) => {
        this.props.updateFileList(file, index)
    }

    openModal = (name, modelId, index) => {
        this.setState(prevState => ({
            openModal: true,
            modelId,
            index,
            selectedModelName: name
        }))
    }

	appendFileToList = ({_id, name, progress, message}) => {
        let index = this.findIndex(this.props.fileList, name);
        let file = {
            _id,
            name: name,
            progress,
            message
        }
        this.saveData(file, index)
    }

    clearError = (index, id) => {
        this.props.removeModel(id)
            .catch(err => console.error('Removing the model failed', err))
            .finally(this.refreshList)
        this.props.removeFileFromList(index)
    }


    displayModal = () => {
        return this.state.openModal && 
        
        <Modal closeModal={this.closeModal}
            contentWidth={"100%"}
            contentHeight="90%"
            containerHeight="inherit"
            modelId={this.state.modelId}
            modelName={this.state.selectedModelName}
            removeModel={this.removeModel}
            approveModel={this.approveModel}
            callingComponent={"Model Uploader"} />
    }

    renderProgress = (progress, name, id, index) => {
        let progressBars
        let button
        let error
        switch (progress) {
            case "Queued":
            case "Upload":
            case "Uploaded":
                progressBars = modelUploadProgressBars("In Queue", 0)
                break
            case 'Decimating_1':
                progressBars = modelUploadProgressBars("", 15)
                break
            case `Decimating_2`:
                progressBars = modelUploadProgressBars("", 30)
                break
            case `Decimating_3`:
                progressBars = modelUploadProgressBars("", 45)
                break
            case `Decimating_4`:
                progressBars = modelUploadProgressBars("", 60)
                break
            case `Decimating_5`:
                progressBars = modelUploadProgressBars("", 75)
                break
            case "Packaging":
                progressBars = modelUploadProgressBars("", 99, () => this.clearError(index, id))
                break
            case "Review":
                button = reviewButton((e) => this.openModal(name, id, index))
                break
            default:
                error = <li id="error-button-container">
                    <span className="clickable" id="error-button" onClick={() => this.clearError(index, id)}>Uploading Error</span>
                </li>
                break
            }
        if (error) return <div className="flex-centered">{error}</div>
        if (button) return button
        if (progressBars) {
            return <li className="flex-centered max-width">
                {progressBars}
                <svg className="clickable" onClick={() => this.clearError(index, id)} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM10.1925 3.75L7.5 6.4425L4.8075 3.75L3.75 4.8075L6.4425 7.5L3.75 10.1925L4.8075 11.25L7.5 8.5575L10.1925 11.25L11.25 10.1925L8.5575 7.5L11.25 4.8075L10.1925 3.75Z" fill="#D7493F" />
                </svg>
            </li>
        }
    }

    render = () => {
        let names = []
        let progressField = []
        let fileList = this.props.fileList
        // console.log("Rendering with fileList:", JSON.stringify(fileList));
        for (const index in fileList) {
            const { progress, state, _id, name } = fileList[index] 
            const status = progress || state; 
            names.push(name)
            progressField.push(this.renderProgress(status, name, _id, index))
        }

    return <div style={{justifyContent: "center", height: "calc(100% - 47px)"}} className="rel flex max-size">
            {this.state.modelId ? this.displayModal() : null}
                <div className={`model-uploader-container flex-column max-size ${this.state.openModal ? "modal-open" : ""}`}>
                    <FileDropZone appendFileToList={this.appendFileToList}/>
                    <FileManager names={names} progress={progressField}/>
                </div>
            </div>
    }
}

export default ModelUploader